import React, { useState } from "react";

const Frequentlyquestion = (props) => {
  const [show, setShow] = useState(false);

  const showQuestion = () => {
    setShow(!show);
  };
  return (
    <>
      <div
        className={`questionSuitableCars ${show ? "show" : null}`}
        onClick={showQuestion}
      >
        <div className="headSuitableCars">
          <span>{props.frequentlyquestion.question}</span>
          <i className={"icon-chevron-down"} />
        </div>
        <p>{props.frequentlyquestion.answer}</p>
      </div>
    </>
  );
};

export default Frequentlyquestion;
